import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-92b0a616"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "appHome" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"24px","font-weight":"bold"} }, "问答应用", -1))
const _hoisted_3 = { style: {"margin-bottom":"30px"} }
const _hoisted_4 = { id: "contextDiv" }

import { ref, watchEffect } from "vue";
import API from "@/api";
import { listAppVoByPageUsingPost } from "@/api/appController";
import message from "@arco-design/web-vue/es/message";
import { REVIEW_STATUS_ENUM } from "@/constant/appEnum";
import AppCart from "@/components/list/AppCart.vue";
import router from "@/router";

//初始值

export default /*#__PURE__*/_defineComponent({
  __name: 'AppHomePage',
  setup(__props) {

const initParams = {
  current: 1,
  pageSize: 8,
  reviewStatus: REVIEW_STATUS_ENUM.PASS,
  sortField: "id",
  sortOrder: "descend",
};
//搜索参数
const searchParams = ref<API.AppQueryRequest>({
  ...initParams,
});
//传递参数
const formParams = ref<API.AppQueryRequest>({});
//数据
const dataList = ref<API.AppVO[]>([]);
//总值
const total = ref<number>(0);
const loading = ref(false);

/**
 * 加载数据
 */
const loadData = async () => {
  loading.value = true;
  const response = await listAppVoByPageUsingPost(searchParams.value);
  if (response.data.code === 0) {
    dataList.value = response.data.data?.records || [];
    total.value = response.data.data?.total || 0;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};
/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});
/**
 * 搜索
 */
const search = () => {
  searchParams.value = { ...initParams, ...formParams.value };
};
/**
 * 当分页变化时，改变搜索条件，触发数据加载
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};
const click = (url: string) => {
  router.push({ path: url });
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_form, {
        model: formParams.value,
        layout: "inline",
        "auto-label-width": "",
        onSubmit: search
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            field: "appName",
            style: {"margin":"0 auto"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                modelValue: formParams.value.appName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formParams.value.appName) = $event)),
                placeholder: "快速发现答题应用",
                style: {"width":"250px"},
                "allow-clear": ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit",
                style: {"width":"100px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createVNode(_component_a_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (click('/add/app'))),
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("创建应用")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_a_list, {
        class: "list-demo-action-layout",
        "grid-props": { gutter: [20, 20], md: 6 },
        bordered: false,
        data: dataList.value,
        "pagination-props": {
          pageSize: searchParams.value.pageSize,
          current: searchParams.value.current,
          total: total.value,
        },
        loading: loading.value,
        onPageChange: onPageChange
      }, {
        item: _withCtx(({ item }) => [
          _createVNode(AppCart, { app: item }, null, 8, ["app"])
        ]),
        _: 1
      }, 8, ["data", "pagination-props", "loading"])
    ])
  ]))
}
}

})